import type { IPlatformDashboardTimeBucket, PlatformDashboardGrowthPeriod } from '@brushfire/types'

/** US-PAD-1-13 — x-axis title matches bucket granularity (day vs week). */
export function growthTrendXAxisTitle(period: PlatformDashboardGrowthPeriod): string {
  return period === 'week' ? 'Day' : 'Week'
}

/** US-PAD-1-14 — tooltip title: calendar date (week) or week label (month). */
export function formatGrowthTrendTooltipTitle(
  bucket: IPlatformDashboardTimeBucket | undefined,
  period: PlatformDashboardGrowthPeriod,
): string {
  if (!bucket) return ''
  if (period === 'month') {
    return bucket.label
  }
  const parsed = new Date(`${bucket.date}T00:00:00`)
  if (Number.isNaN(parsed.getTime())) {
    return bucket.label
  }
  return parsed.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}
